'use strict'

export const LOGIN_PAGE = '/membership/login'
export const FIND_PASSWORD_PAGE = '/membership/password/find'

export const HOME_PAGE = '/'
